import type { BloomMenuTheme } from '@iheartjane/data-access';
import { PRODUCT_CARD_SIZE_MAP } from '@iheartjane/menu';

export const DEFAULT_PRODUCT_CARD_WIDTH = 240;

export const getThemedProductCardWidth = (theme: BloomMenuTheme): number => {
  const cardSize = theme?.bloom?.product_cards?.card_size;

  return cardSize
    ? PRODUCT_CARD_SIZE_MAP[cardSize]
    : DEFAULT_PRODUCT_CARD_WIDTH;
};
